import Axios from "functions/Axios";
import { CMS_DELETE_NAVIGATIONS, CMS_DOMAINS, CMS_GET_NAVIGATIONS, ERROR_MEDIA_LIBRARY_CONTENT, LOADER_MEDIA_LIBRARY_CONTENT, SET_CONTENT_TYPE_COLLECTION, SET_CONTENT_TYPE_COMPONENTS, SET_CONTENT_TYPE_ERROR, SET_CONTENT_TYPE_LOADING, SET_CONTENT_TYPE_SINGLE, SET_CONTENT_TYPE_SUCCESS, SET_MEDIA_LIBRARY_CONTENT } from "./types";
import { CMS_API_URL } from "Constant";



export const changeCollectionsdata = (pageNo) => ({
  type: SET_CONTENT_TYPE_COLLECTION,
  payload: pageNo,
});
export const changeSinglesdata = (pageNo) => ({
  type: SET_CONTENT_TYPE_SINGLE,
  payload: pageNo,
});
export const changeComponentsdata = (pageNo) => ({
  type: SET_CONTENT_TYPE_COMPONENTS,
  payload: pageNo,
});

export const GetMedia = (domainId, page = 0, search = "", selectedIds = []) => {
  return (dispatch) => {
    //   dispatch({ type: LOADER_MEDIA_LIBRARY_CONTENT });
    const selectedIdsParam =
      selectedIds && selectedIds.length > 0
        ? `&selectedIds=${selectedIds.join(",")}`
        : "";
    return Axios.get(`${CMS_API_URL}/media/getAll/${domainId}?page=${page}&size=${24}&searchKeyword=${search}${selectedIdsParam}`)
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: SET_MEDIA_LIBRARY_CONTENT,
            payload: res.data.data,
          });
          return true;
        } else {
          throw new Error();
        }
      })
      .catch((e) => {
        // dispatch({
        //     type: ERROR_MEDIA_LIBRARY_CONTENT,
        // });
        return false;
      });
  };
};
export const GetSingles = (id) => {
  return (dispatch) => {
    return Axios.get(`${CMS_API_URL}/single/getAll/${id}`)
      .then((res) => {
        if (res.status === 200) {

          const fulljson = res.data.data.map(item => ({
            ...JSON.parse(item.fieldsJson),
            relationShipList: item.relationShipList,
            TypeId: item.singleTypeId,
            id: item.singleTypeId
          }));

          dispatch({
            type: SET_CONTENT_TYPE_SINGLE,
            payload: fulljson,
          });
          return true;
        } else {
          throw new Error('Failed to fetch singles.');
        }
      })
      .catch((error) => {
        console.error('Error fetching singles:', error);
        return false;
      });
  };
};

export const GetComponents = (id) => {
  return (dispatch) => {
    return Axios.get(`${CMS_API_URL}/component/getAll/${id}`)
      .then((res) => {
        if (res.status === 200) {
          const fulljson = res.data.data.map(item => ({
            ...JSON.parse(item.fieldsJson),
            TypeId: item.componentId,
            id: item.componentId
          }));

          dispatch({
            type: SET_CONTENT_TYPE_COMPONENTS,
            payload: fulljson,
          });
          return true;
        } else {
          throw new Error('Failed to fetch singles.');
        }
      })
      .catch((error) => {
        console.error('Error fetching singles:', error);
        return false;
      });
  };
};


export const GetCollections = (id) => {
  return (dispatch) => {
    dispatch({
      type: SET_CONTENT_TYPE_LOADING,
      payload: [],
    });


    return Axios.get(`${CMS_API_URL}/collection/getAll/${id}`)
      .then((res) => {
        if (res.status === 200) {

          const fulljson = res.data.data.collectionList.map(item => ({
            ...JSON.parse(item.fieldsJson),
            relationShipList: item?.relationShipList,
            TypeId: item.collectionTypeId,
            id: item.collectionTypeId,
            plural: item.plural
          }));
          fulljson.sort((a, b) => a.data.label.localeCompare(b.data.label))
          dispatch({
            type: SET_CONTENT_TYPE_COLLECTION,
            payload: fulljson,
          });
          const fulljsonsingle = res.data.data.singleList.map(item => ({
            ...JSON.parse(item.fieldsJson),
            relationShipList: item.relationShipList,
            TypeId: item.collectionTypeId,
            id: item.collectionTypeId,
            plural: item.plural,

          }));
          fulljsonsingle.sort((a, b) => a.data.label.localeCompare(b.data.label))
          dispatch({
            type: SET_CONTENT_TYPE_SINGLE,
            payload: fulljsonsingle,
          });
          dispatch({
            type: SET_CONTENT_TYPE_SUCCESS,
            payload: [],
          });

          return true;
        } else {
          throw new Error('Failed to fetch singles.');
        }
      })
      .catch((error) => {
        console.error('Error fetching singles:', error);
        return false;
      });
  };
};

export const setDomains = (domains) => ({
  type: CMS_DOMAINS,
  payload: domains,
});

export const GetDomains = () => {
  return (dispatch) => {
    //   dispatch({ type: LOADER_MEDIA_LIBRARY_CONTENT });
    return Axios.get(`${CMS_API_URL}/details/get`)
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: CMS_DOMAINS,
            payload: res.data.data,
          });
          return true;
        } else {
          throw new Error();
        }
      })
      .catch((e) => {
        // dispatch({
        //     type: ERROR_MEDIA_LIBRARY_CONTENT,
        // });
        return false;
      });
  };
};



export const GetNavigations = (id) => {
  return (dispatch) => {
    dispatch({
      type: SET_CONTENT_TYPE_LOADING,
      payload: [],
    });

    return Axios.get(`${CMS_API_URL}/navigation/getAll/${id}`)
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: CMS_GET_NAVIGATIONS,
            payload: res.data.data,
          });
          dispatch({
            type: SET_CONTENT_TYPE_SUCCESS,
            payload: [],
          });
          return true;
        } else {
          dispatch({
            type: SET_CONTENT_TYPE_SUCCESS,
            payload: [],
          });
          throw new Error();
        }

      })
      .catch((e) => {
        dispatch({
          type: SET_CONTENT_TYPE_SUCCESS,
          payload: [],
        });
        return false;
      });
  };
};



export const DeleteNavigation = (index) => {
  return (dispatch) => {
    dispatch({
      type: CMS_DELETE_NAVIGATIONS,
      payload: index,
    });

  };
}

